import 'uikit/dist/js/uikit'
import '../css/uikit.css'

import '../css/style.css'
import 'font-awesome/css/font-awesome.css'

import '../css/custom.css'

import '../scss/public.scss'